import React, { useState } from 'react';
import { Toggle } from '@econsult/econsult-ui/dist/components/Toggle';
import { Textarea } from '@econsult/econsult-ui/dist/components/Textarea';
import Button from 'components/Button';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useAppState } from 'store/configureStore';
import { sendFeedback } from 'store/action/feedback';
import * as styles from './styles';

interface FeedbackModalProps {
    closeModal: () => void;
}

const StyledTextarea = styled(Textarea)`
  .MuiInputBase-input {
    color: #333333 !important;
  }
`;

const StyledToggle = styled(Toggle)`
  font-size: 16px !important;
`;

export const FeedbackModalWithSummary: React.FC<FeedbackModalProps> = ({
  closeModal,
}) => {
  const { summary: { consultationId, currentSummary: initialSummary } } = useAppState();
  const location = useLocation();
  const transcript = location.state?.transcript || 'No transcript available';

  const [comment, setComment] = useState('');
  const [includeSummary, setIncludeSummary] = useState(false);

  const handleSave = () => {
    const details: { consultationId: string; summary?: string; transcript?: string } = { consultationId };
    if (includeSummary) {
      details.summary = initialSummary;
      details.transcript = transcript;
    }
    sendFeedback(comment, details);
    closeModal();
  };

  return (
    <>
      <div style={{ marginBottom: '1rem', color: '#333333' }}>
        <StyledTextarea
          fullWidth
          autoFocus
          multiline
          minRows={4}
          maxRows={4}
          id="feedback-textarea"
          placeholder="How could Hi&nbsp;Scribe be improved?"
          style={{ fontSize: '16px', color: '#333333 !important' }}
          sx={{ color: '#333 !important' }}
          onChange={(event: { target: { value: React.SetStateAction<string>; }; }) => setComment(event.target.value)}
        />
      </div>
      <div style={{ marginBottom: '1rem' }}>
        <StyledToggle
          onClick={() => setIncludeSummary(!includeSummary)}
          isChecked={includeSummary}
          id="include-summary-transcription"
          label="Send transcription and summary"
        />
      </div>
      If you decide to include the transcription and summary when submitting feedback,
      please note this will be accessible to select Hi&nbsp;Scribe team members and will be deleted after two weeks.
      <styles.FlexGroup>
        <Button
          id="feedback-summary-send-modal-button"
          onClick={closeModal}
          buttonText="Cancel"
          icon={null}
          iconPosition="left"
          state="secondary"
          disabled={false}
        />
        <Button
          id="feedback-summary-send-modal-button"
          onClick={handleSave}
          buttonText="Send"
          icon={null}
          iconPosition="left"
          state="primary"
          disabled={!comment}
        />
      </styles.FlexGroup>
    </>
  );
};
